function removeEComposerFooter() {
  const tag = document.querySelector("vtkt");
  if (tag) {
    tag.remove();
    console.log("EComposer branding removed.");
  }
}

// Try to remove repeatedly in case it's added later
const interval = setInterval(removeEComposerFooter, 500);

// Stop trying after 10 seconds
setTimeout(() => clearInterval(interval), 10000);
